import { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  Divider,
  Typography,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
// import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import Breadcrumb from "../../components/breadcrumb/breadcrumb";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EditMyProfile from "./edit-myprofile/edit-myprofile";
import { useDispatch, useSelector } from "react-redux";
import { userType } from "../../utils/Constant";
import { currentUserRequest } from "../../redux/users/slice";
import Loading from "../../components/loading/loading";
import ResetPassword from "./reset-password/reset-password";
import Notification from "../../components/notification/notification";
import ContactSpectrum from "../../components/contact-spectrum/constact-spectrum";

export default function MyProfile() {
  const [showEditMyProfile, setShowEditMyProfile] = useState(false);
  const [primaryEmail, setPrimaryEmail] = useState<any>();
  const [altEmails, setAltEmails] = useState<any>([]);
  const [primaryPhone, setPrimaryPhone] = useState<any>();
  const [altPhones, setAltPhones] = useState<any>([]);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const dispatch = useDispatch();

  const { currentUser } = useSelector((state: any) => state.user.user);
  const { loading } = useSelector((state: any) => state.user);

  useEffect(() => {
    if (currentUser) {
      const filterPrimaryEmails = currentUser.emails.filter(
        (email: any) => email.isPrimary === true
      );
      const filterAltEmails = currentUser.emails.filter(
        (email: any) => email.isPrimary === false
      );
      setPrimaryEmail(filterPrimaryEmails[0]);
      setAltEmails(filterAltEmails);
      const filterPrimaryPhones = currentUser.phones.filter(
        (phone: any) => phone.isPrimary === true
      );
      const filterAltPhones = currentUser.phones.filter(
        (phone: any) => phone.isPrimary === false
      );
      setPrimaryPhone(filterPrimaryPhones[0]);
      setAltPhones(filterAltPhones);
    } else {
      dispatch(currentUserRequest());
    }
  }, [currentUser, dispatch]);

  const handleEditUserDetails = () => {
    setShowEditMyProfile(true);
  };

  const resetPasswordAlert = () => {
    setShowAlert(true);
  };

  return (
    <>
      {currentUser?.userType !== userType.client && <ContactSpectrum />}
      <Box mt={currentUser?.userType === userType.client ? 2 : 0}>
        <Breadcrumb />
      </Box>
      <Box className="user-info-layout">
        <Avatar className="user-avatar" alt="Avatar" variant="circular">
          <PersonIcon />
        </Avatar>
        <Box className="margin-left">
          <Typography variant="h4">{currentUser?.firstName}</Typography>
          <Box className="user-details-content">
            {currentUser?.userType === userType.client && (
              <Box className="user-location-content">
                <BusinessOutlinedIcon className="user-location-icon" />
                <Typography className="user-location-txt">
                  {currentUser?.clientName}
                </Typography>
              </Box>
            )}
            {currentUser?.userType === userType.inspector && (
              <Box className="user-location-content">
                <ConstructionOutlinedIcon className="user-location-icon" />
                <Typography className="user-location-txt">
                  {currentUser?.inspectorFirmName}
                </Typography>
              </Box>
            )}
            {currentUser?.userType === userType.tenant && (
              <Box className="user-location-content">
                <img
                  src={require("../../assets/Vision_Stone.svg").default}
                  alt="Internal User"
                />
                <Typography className="user-location-txt">Spectrum</Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">User Details</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={handleEditUserDetails}
          >
            Edit
          </Button>
        </Box>
        <Box className="display-name-layout">
          <Typography className="label-txt">Title</Typography>
          <Typography>
            {currentUser?.title ? `${currentUser?.title}` : "-"}
          </Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Name</Typography>
          <Typography>
            {currentUser &&
              `${currentUser?.firstName} ${currentUser?.lastName}`}
          </Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Username</Typography>
          <Typography>{currentUser && `${currentUser?.username}`}</Typography>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Email</Typography>
          <Box>
            {primaryEmail && (
              <Box display={"flex"} alignItems="center">
                <Typography>{primaryEmail?.emailAddress}</Typography>
                <Chip
                  sx={{ ml: 1 }}
                  label="primary"
                  variant="outlined"
                  color="primary"
                  size="small"
                />
              </Box>
            )}
            {altEmails?.map((email: any, index: number) => (
              <Typography key={index}>{email?.emailAddress}</Typography>
            ))}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Phone</Typography>
          <Box>
            {primaryPhone && (
              <Box display={"flex"} alignItems="center">
                <Typography>{primaryPhone?.phoneNumber}</Typography>
                <Chip
                  sx={{ ml: 1 }}
                  label="primary"
                  variant="outlined"
                  color="primary"
                  size="small"
                />
              </Box>
            )}
            {altPhones?.map((phone: any, index: number) => (
              <Typography key={index}>{phone?.phoneNumber}</Typography>
            ))}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">Reset Password</Typography>
          <Button
            sx={{ mt: 0.5 }}
            variant="outlined"
            onClick={() => setShowResetPassword(true)}
          >
            Reset Password
          </Button>
        </Box>
      </Card>

      {showEditMyProfile && (
        <EditMyProfile
          showDialog={showEditMyProfile}
          closeDialog={() => setShowEditMyProfile(false)}
          data={currentUser}
        />
      )}

      {showResetPassword && (
        <ResetPassword
          showDialog={showResetPassword}
          closeDialog={() => setShowResetPassword(false)}
          onResetSuccess={resetPasswordAlert}
        />
      )}

      {loading && <Loading />}

      {showAlert && (
        <Notification
          show={showAlert}
          title="Reset Password Successfully"
          onClose={() => setShowAlert(false)}
        />
      )}
    </>
  );
}
